// react
import React from "react";
import { Link } from "react-router-dom";
// components
import { Button, Icon } from "semantic-ui-react";

// component
function ButtonBack({ link }) {
    // template
    return (
        <Button
            as={Link}
            to={link}
            type="button"
            style={{
                marginBottom: "0",
                marginTop: "0",
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
                background: "transparent",
                color: "var(--primary)",
                border: "1px solid var(--primary)",
                borderRadius: "8px",
                padding: "0.6rem 1rem",
                fontSize: "0.9rem",
                fontWeight: "500",
                transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = "var(--primary)";
                e.currentTarget.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "var(--primary)";
            }}
        >
            <Icon name="arrow left" style={{ margin: 0, fontSize: "1rem" }} /> Naspäť
        </Button>
    );
}

export default ButtonBack;
